import {cn} from "../../lib/utils.ts";

export interface SegmentedControlOption<T extends string> {
    value: T;
    label: string;
}

interface SegmentedControlProps<T extends string> {
    value: T;
    options: SegmentedControlOption<T>[];
    onChange: (value: T) => void;
    ariaLabel?: string;
}

export function SegmentedControl<T extends string>({
    value,
    options,
    onChange,
    ariaLabel,
}: SegmentedControlProps<T>) {
    return (
        <div
            className="inline-flex rounded-lg border border-gray-200 bg-gray-100 p-0.5"
            role="group"
            aria-label={ariaLabel}
        >
            {options.map((option) => (
                <button
                    key={option.value}
                    type="button"
                    className={cn(
                        "rounded-md px-3.5 py-1.5 text-[13px] font-semibold",
                        value === option.value
                            ? "bg-white text-primary shadow-sm"
                            : "text-gray-500 hover:text-gray-700",
                    )}
                    onClick={() => onChange(option.value)}
                >
                    {option.label}
                </button>
            ))}
        </div>
    );
}
